
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IUnit } from "@tylertech/tyler-api-types";

/**
 * InventoryUnitService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class InventoryUnitService {
    private readonly $apiService = inject(ApiService);
    
    AddUnit(pUnit: IUnit): Promise<IUnit> {
        return this.$apiService.sendAuth("IInventoryUnitService/AddUnit", pUnit);
    }
}
